module.exports = __webpack_public_path__ + "img/galery23.9685061c.jpg";